import { defineComponent as _defineComponent } from 'vue'
import { computed, PropType } from 'vue'
import { IEvento } from '../../common/types/Evento'


export default /*#__PURE__*/_defineComponent({
  __name: 'IconeDoEvento',
  props: {
	evento: { type: Object as PropType<IEvento>, required: true },
},
  setup(__props) {

const props = __props;



const iconMap: {[key: string]: any} = {
	['Ordinária - Instrução']: '$vuetify.icons.teacher',
	['Ordinária - Outras']: '$vuetify.icons.conversation',
	['Ordinária - J. Ritualístico']: '$vuetify.icons.dish',
	['Ordinária - Finanças']: '$vuetify.icons.money',
	['Magna - Iniciação']: 'mdi-chess-king',
	['Magna - Elevação']: 'mdi-chess-king',
	['Magna - Exaltação']: 'mdi-chess-king',
	['Magna - Instalação']: 'mdi-chess-king',
	['Magna - Outras']: 'mdi-chess-king',
	['Extraordinária']: '$vuetify.icons.hand',
	['Pública']: '$vuetify.icons.value',
	['EVENTO']: '$vuetify.icons.dinner',
	['Evento']: '$vuetify.icons.value',
}

const icon = computed((): string => iconMap[props.evento.tipoDaSessao.nome] || '')

return { __sfc: true,props, iconMap, icon }
}

})